// src/pages/SettingsPage/components/WorkspaceTable.tsx
import { useAuth0 } from "@auth0/auth0-react";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { NoteBlockContainer } from "../../note";
import { useApps, useAppId } from "../../../hook";
import { useRenameWorkspace, useSetSelectedApp } from "../../../hook/settings";
import { DynamicTextField } from "../../dynamicTextField";

export const WorkspaceTable: React.FC = () => {
  const [apps, setApps] = useApps();
  const [appId, setAppId] = useAppId();
  const setSelectedApp = useSetSelectedApp();
  const renameWorkspace = useRenameWorkspace();
  const { user } = useAuth0();

  const currentApp = apps.find((app) => app.id === appId);

  return (
    <>
      <NoteBlockContainer name="My Workspaces">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Workspace</TableCell>
              <TableCell>Selected</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apps.map((app) => {
              const checked = app.id === appId;
              return (
                <TableRow key={app.id}>
                  <TableCell>{app.name}</TableCell>
                  <TableCell>
                    <Checkbox
                      onClick={() => {
                        setSelectedApp({ appId: app.id, email: user?.email! });
                      }}
                      disabled={checked}
                      checked={checked}
                    ></Checkbox>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </NoteBlockContainer>
      <NoteBlockContainer name="Workspace Name" description="Rename this workspace. Changes take effect immediately.">
        <DynamicTextField
          text={currentApp?.name ?? ""}
          setText={renameWorkspace}
          placeholder="Workspace name"
        />
      </NoteBlockContainer>
    </>
  );
};
